import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import EHR from '@td/ehr';
import { EhrFileUploadsContainer } from 'app/FileUploads/components/ehr-file-uploads-container';
import { ElationTableOfDocuments } from '@td/emr';
// Import the CSS from EHR library
import '@td/ehr/dist/index.css';
import tasDisplayExternalEhrDocumentList from './queries/tasDisplayExternalEhrDocumentList.graphql';
import { useQuery } from '@apollo/client';
import safeJsonParse from '@td/emr/src/utils/json/safeJsonParse';
import { get } from 'lodash';

const EHRWrapper = props => {
  const onLoad = () => {
    // TODO CKAN-1843: Move all of this EHR toggling code from the coffeescript to react
    $('#consultation_history_ehr div.ct .ehr_content').hide();
    new EhrToggler($('#consultation_history_ehr div.ct')).toggle();
    $('#intakes_list.ct h3:first').click(); // BHDERM-203 expand intakes section
    $('#consultation_history_ehr .ehr_section_container').show();
  };

  // inject section-specific context / dependencies
  const [sectionSpecificContext, setSectionSpecificContext] = useState(
    { react_images_and_documents_section: { EhrFileUploadsContainer } }
  );
  const { loading, error, data } = useQuery(tasDisplayExternalEhrDocumentList, {
    variables: { member_id: props.memberId }
  });

  useEffect(() => {
    const documentList = get(data, 'member.displayExternalEhrDocumentList');
    const responseStatus = get(safeJsonParse(documentList), 'status');
    if (responseStatus === 'success') {
      setSectionSpecificContext(
        { react_images_and_documents_section: { EhrFileUploadsContainer, ElationTableOfDocuments } }
      );
    }
  }, [data]);

  return (
    <EHR
      {...props}
      userType="Admin"
      containerId="consultation_history_ehr"
      onLoad={onLoad}
      sectionSpecificContext={sectionSpecificContext}
      editable
    />
  );
};

EHRWrapper.propTypes = {
  consultationId: PropTypes.number.isRequired,
  memberId: PropTypes.number.isRequired
};

export default EHRWrapper;
